import styled from 'styled-components';

export const RealEstateFakeInputWrapper = styled.div`
  label {
    font-size: 15px;
    margin-bottom: 8px;
    font-weight: 500;
    color: #666666;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #EEF0F4;
    border-radius: 8px;
    height: 54px;
    font-size: 16px;
    font-weight: 500;
    padding: 16px;
    color: #444444;

    a {
      display: flex;
      align-items: center;
      justify-content: center;

      transition: filter .2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;
